import React from 'react'
import { TableSeeker } from '@ui-seeker/core'
import AppTitleWithPopup from '@components/@base/TitleWithPopup'
import { Box } from '@mui/material'
import { isEmpty } from '@ui-seeker/utils'
import { dsColorNew } from '@palette'

import AppEmptyLine from '@components/@base/EmptyLine'
import AppTableSearch from './Search'
import AppTableFilterHeader from './FilterHeader'


export default function AppDataTable({ title, toolbarProps = {}, ...props }) {

	return <TableSeeker
		title={title}
		titleProps={{ variant: "h6", mt: 1 }}
		{...props}
		textLabels={{
			...props?.textLabels,
			// the library's empty line, same words, in the app's muted look
			body: { noMatch: <AppEmptyLine/>, ...props?.textLabels?.body },
			filter: { reset: 'Reset', ...props?.textLabels?.filter },
		}}
		options={{
			rowsPerPage: 50,
			rowsPerPageOptions: [5, 20, 50, 100, {label: 'All', value: props.data.length}],
			enhancedSetRowProps: (rowData, dataIndex, idx) => ({
				sx: {
					backgroundColor: idx % 2 === 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
					borderColor: dsColorNew.grayBorder,
					"&.MuiTableRow-hover:hover": { backgroundColor: dsColorNew.hoverBgLight },
				}
			}),
			search: false,
			print: false,
			viewColumns: false,
			customSearchRender: (searchText, onSearch, onHide) => <AppTableSearch onSearch={onSearch} onHide={onHide}/>,
			// the floating selection bar sits above the toolbar, so the title and search stay put while rows are selected
			...(props?.options?.customToolbarSelect && { selectToolbarPlacement: 'above' }),
			customFilterDialogFooter: filterList => <AppTableFilterHeader
				filterList={filterList}
				columns={props.columns}
				setFilterChipProps={props?.options?.setFilterChipProps}
			/>,
			...props?.options,
			customToolbar: () => <Box sx={{ display: "flex", gap: .5 }}>
				{props?.options?.customToolbar && props?.options?.customToolbar()}
				{!isEmpty(toolbarProps) && <AppTitleWithPopup {...toolbarProps} />}
			</Box>,
		}}
	/>
}
